export default __webpack_public_path__ + "static/media/pic3.1f40819a.jpg";